import { Check, AlertCircle, Circle, Minus } from "lucide-react";

const STEP_LABELS = [
  null, "Arrival", "Customer", "Consent", "Damage", "Photos", "Scope", "Moisture",
  "Sketch", "Equip", "Hazards", "Inventory", "Debrief", "Estimate", "Paperwork", "Sign-off",
];

const STATUS_VISUAL = {
  complete:    { bg: "bg-emerald-500",  ring: "ring-emerald-300", icon: Check,        text: "text-white" },
  in_progress: { bg: "bg-blue-500",     ring: "ring-blue-300",    icon: AlertCircle, text: "text-white" },
  na:          { bg: "bg-zinc-400",     ring: "ring-zinc-300",    icon: Minus,        text: "text-white" },
  incomplete:  { bg: "bg-white border-2 border-zinc-300", ring: "ring-transparent", icon: Circle, text: "text-zinc-400" },
};

export default function StepProgress({ workflow, currentStep, onJump }) {
  const steps = workflow?.steps || {};
  return (
    <div className="bg-white border-b border-zinc-200 px-2 py-2 overflow-x-auto"
         data-testid="inspection-step-progress">
      <div className="flex items-center gap-1 min-w-max px-1">
        {Array.from({ length: 15 }).map((_, idx) => {
          const num = idx + 1;
          const st  = steps[String(num)]?.status || "incomplete";
          const isCurrent = num === currentStep;
          const v = STATUS_VISUAL[st] || STATUS_VISUAL.incomplete;
          const Icon = v.icon;
          return (
            <button
              key={num}
              onClick={() => onJump && onJump(num)}
              className={`flex-shrink-0 flex flex-col items-center gap-0.5 px-1 py-1 rounded-lg
                          transition-all active:scale-95
                          ${isCurrent ? "ring-2 ring-amber-400" : ""}`}
              data-testid={`step-pill-${num}`}
              aria-label={`Step ${num} ${STEP_LABELS[num]} — ${st}`}
            >
              <div className={`w-7 h-7 rounded-full flex items-center justify-center ${v.bg} ${v.ring} ring-2`}>
                <Icon className={`w-3.5 h-3.5 ${v.text}`} />
              </div>
              <span className={`text-[9px] font-semibold whitespace-nowrap ${isCurrent ? "text-amber-700" : "text-zinc-500"}`}>
                {num}. {STEP_LABELS[num]}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
